/**
 * Maps error name and description to a Sentry error object,
 * which you can pass to captureError() Sentry function.
 */
export default function mapSentryEvent(errorName, errorDescription) {
  return {
    exception: {
      values: [{
        type: errorName,
        ...(errorDescription && {
          value: errorDescription
        })
      }]
    }
  };
}